import { Injectable, signal } from '@angular/core';
import { STORAGE_KEYS } from '@core/constants/storage-keys';
import { Menu } from '@domain/menu/menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  // Signal para controlar o estado do menu
  private displaySignal = signal<boolean>(this.loadMenuStateFromStorage());

  // Signal para controlar o item do menu atual
  private currentMenuItemSignal = signal<Menu | null>(
    this.loadCurrentMenuItemFromStorage()
  );

  // Método para abrir o menu
  open(): void {
    this.displaySignal.set(true);
    this.saveMenuStateToStorage(true); // Persistir no localStorage
  }

  // Método para fechar o menu
  close(): void {
    this.displaySignal.set(false);
    this.saveMenuStateToStorage(false); // Persistir no localStorage
  }

  // Método para definir o item de menu atual
  setCurrentMenuItem(item: Menu): void {
    this.currentMenuItemSignal.set(item);
    this.saveCurrentMenuItemToStorage(item); // Persistir no localStorage
  }

  // Retorna o Signal do estado do menu
  getDisplay() {
    return this.displaySignal;
  }

  // Retorna o Signal do item do menu atual
  getCurrentMenuItemSignal() {
    return this.currentMenuItemSignal;
  }

  // Método para salvar o estado de exibição do menu no localStorage
  private saveMenuStateToStorage(state: boolean): void {
    localStorage.setItem('app_menu_display', JSON.stringify(state));
  }

  // Método para carregar o estado do menu do localStorage
  private loadMenuStateFromStorage(): boolean {
    const storedState = localStorage.getItem('app_menu_display');
    return storedState ? JSON.parse(storedState) : false; // Valor padrão: fechado
  }

  // Método para salvar o item do menu no localStorage
  private saveCurrentMenuItemToStorage(item: Menu): void {
    localStorage.setItem(STORAGE_KEYS.CURRENT_MENU, JSON.stringify(item));
  }

  // Método para carregar o item do menu do localStorage
  private loadCurrentMenuItemFromStorage(): Menu | null {
    const storedItem = localStorage.getItem(STORAGE_KEYS.CURRENT_MENU);
    return storedItem ? JSON.parse(storedItem) : null; // Valor padrão: null
  }
}
